import { render } from "./MyAppointmentsView.vue?vue&type=template&id=54d07cc4"
import script from "./MyAppointmentsView.vue?vue&type=script&lang=js"
export * from "./MyAppointmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__